<template>
    <el-drawer
        :title="`${item.id?'编辑':'新增'}代码`"
        :visible.sync="show"
        :wrapperClosable="false"
        direction="rtl"
        size="700px"
        :before-close="close">
        <div class="panel fx-g1">
            <el-form ref="form" :model="form" label-width="150px" class="edit_form">
                <el-form-item label="代码名称" v-check="{'必填': !form.title}">
                    <el-input v-model="form.title"></el-input>
                </el-form-item>
                 <el-form-item label="编程语言" v-check="{'必选': !form.type}">
                    <el-select v-model="form.type" placeholder="编程语言"  @change="loadFuncs">
                        <el-option
                            v-for="item in lessonTypes"
                            :key="item.optionValue"
                            :label="item.optionText"
                            :value="item.optionValue">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="标签">
                    <el-input v-model="form.tags" placeholder="多个标签用 ，隔开"></el-input>
                </el-form-item>
                <el-form-item label="演示代码">
                    <el-upload
                        class="upload-demo"
                        action=""
                        :limit="1"
                        :multiple="false"
                        :on-remove="removeCode"
                        :file-list="form.codes">
                        <el-button size="small" type="primary" @click.stop="setLessonCode(form)">
                            {{form.codes[0] ? "重新编辑" : "去编辑"}}
                        </el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item label="简介">
                    <el-input
                        type="textarea"
                        placeholder="请输入内容"
                        v-model="form.content"
                        maxlength="255"
                        :rows="5"
                        show-word-limit
                    >
                    </el-input>
                </el-form-item>
                <el-form-item label="设置知识点">
                    <el-cascader placeholder="任务知识点筛选" style="width:400px;"
                        v-model="knowledgeIds" clearable
                        :options="options"
                        :props="{expandTrigger: 'hover',
                        multiple: true,
                        checkStrictly : true
                        }"
                        :show-all-levels="false"
                        @change="handleChange"></el-cascader>
                </el-form-item>

            </el-form>
        </div>
        <span class="fx fx-center">
            <el-button type="primary" @click="sub()">保存</el-button>
            <el-button @click="close()">关 闭</el-button>
        </span>
    </el-drawer>
</template>

<style scoped>
    .task {
        border-radius: 6px;
        border: 1px solid var(--border);
        min-height: 40px;
        position: relative;
        padding: 20px;
    }

    .task_close {
        position: absolute;
        right: 10px;
        top: 10px;
        color: var(--lighter);
        cursor: pointer;
        font-size: 20px;
    }

    .task_close:hover {
        color: var(--primary);
    }

    .task_form {
        width: 80%;
    }

</style>


<script>

    import {mapMutations} from "vuex";
    export default {
        props: [
            "item",
            "showBox",
        ],
        data() {
            return {
                show: false,
                form: {
                    ...this.item,
                },
                lessonTypes: [],
                options: [],
                defaultProps: {
                    children: 'children',
                    label: 'name',
                    disabled: true
                },
                knowledgeIds:[],
            }

        },
        computed: {
        },
        methods: {
            ...mapMutations([
                "addStorageHandler",
                "removeStorageHandler",
            ]),
            setLessonCode(lesson) {
                // 临时字段，设置一个标识，拱多页面间数据共享用
                // 应该用id的，但是新增课程没有id，只能用这个了
                if (!lesson.caseFlag) {
                    lesson.caseFlag = new Date().getTime();
                }
                let key = "lesson_case_"+lesson.caseFlag;
                let _this = this;
                // let handler = function(event) {
                //     let data = event.data; //{type: "case_code", id:key, url:"七牛地址"}
                //     if(data.type == "case_code" && data.id == key) {
                //         console.debug("成功保存示例代码", data);
                //         _this.$showSuccess("检测到示例代码成功保存", 5000);
                //         let code = lesson.codes[0];
                //         if (code) {
                //             _this.$set(code, "url", data.url);
                //         } else {
                //             _this.$set(lesson.codes, 0, {category:4, url: data.url, name: "示例代码"});
                //         }
                //         window.removeEventListener("message",handler, false);
                //     }
                // }
                // /**
                //  * 跨域页面通信 处理，参考https://developer.mozilla.org/zh-CN/docs/Web/API/Window/postMessage
                //  * 目前主要是 课程任务的示例代码编辑
                //  */
                // window.addEventListener("message", handler, false)
                this.addStorageHandler({
                    key: key,
                    handler: (e) => {
                        if (e.key == key) {
                            console.debug("成功保存示例代码", e);
                            this.$showSuccess("检测到示例代码成功保存", 5000);
                            let code = lesson.codes[0];
                            if (code) {
                                this.$set(code, "url", e.newValue);
                            } else {
                                this.$set(lesson.codes, 0, {category:4, url: e.newValue, name: "示例代码"});
                            }

                        }
                    }
                })
                this.addStorageHandler({
                    key: key+"_cover",
                    handler: (e) => {
                        if (e.key == key+"_cover") {
                            console.debug("成功保存示例封面", e);
                            let code = lesson.codes[0];
                            this.$set(code, "coverImg", e.newValue);
                        }
                    }
                })
                let codeUrl = lesson.codes[0] ? lesson.codes[0].url : "";
                localStorage.setItem(key, codeUrl)
                this.$goEditCode(this.form.type,"mode=case&id="+key);
                this.$showWarn("请到新打开的页面中编辑代码，编辑完成后点击上方的【保存代码】按钮", 5000);
            },
            removeCode() {
                this.form.codes.splice(0, 1);
            },
            close() {
                this.$emit("close");
            },
            sub() {
                if(this.knowledgeIds.length > 0){
                    for (const i in this.knowledgeIds) {
                        let data = this.knowledgeIds[i];
                        this.knowledgeIds[i] = data[this.knowledgeIds[i].length-1];
                    }
                }
                let resources = [...this.form.codes];
                if(resources.length == 0){
                    this.$showError("请编辑代码再保存");
                    return;
                }
                //  {category:4, url: data.url, name: "示例代码"}
                this.$checkForm(this.$refs.form).then(success => {
                    let data = {
                        ...this.form,
                        resources: resources,
                        knowledgeIds:this.knowledgeIds.length > 0 ? this.knowledgeIds.join(",") : null
                    }
                    if (success) {
                        //校验通过，干什么....
                        this.$ajaxPost("/codeBase/save", {
                            codeBase: data
                        }, (data) => {
                            this.$showSuccess("保存成功");
                            this.$emit("submit", data.result);
                        })
                    } else {
                        this.$showError("请输入内容再保存");
                    }
                })

            },
            analyseForm(item) {
                this.form = {
                    ...item,
                    codes: item.codes ? item.codes : [],
                }
            },
            loadLessonTypes() {
                this.$ajaxGet("/common/lessonTypeByExamQuestion", (data) => {
                    this.lessonTypes = data.result;

                })
            },
            handleChange(value) {
                console.log(value);
            },
            loadFuncs() {
                this.$ajaxPost("/knowledge/knowledgeByTask",{form:{type:this.form.type}} , (data) => {
                    this.options = data.result;
                })
            },
        },
        mounted() {
            this.show = true;
        },
        created() {

            this.analyseForm(this.item);
            this.loadLessonTypes();
            this.loadFuncs();
            if(this.item.id > 0){
                //this.loadFuncs();
                if(this.item.knowledgeListIds != 'undefined'){
                    this.item.knowledgeListIds.forEach(item => {
                        this.knowledgeIds.push(item.split(","));
                    });
                }
            }else{
                this.form.type = 1;
            }
        },
        beforeDestroy() {
            //清除Storage回调处理
            if (this.form.caseFlag) {
                this.removeStorageHandler("lesson_case_"+this.form.caseFlag);
            }
        }

    }
</script>
